import { z } from "zod";
const text = z.string().trim().min(1).max(200);
export const AdminQuery = z.object({
  q: z.string().max(200).default(""),
  offset: z.coerce.number().int().min(0).default(0),
  limit: z.coerce.number().int().min(1).max(100).default(30),
});
export const AdminBatch = z.strictObject({
  name: text,
  planCode: text,
  quantity: z.number().int().min(1).max(10000),
  channel: z.string().max(200).optional(),
  deadline: z.iso.datetime().optional(),
});
export const AdminPlan = z.strictObject({
  code: z.string().regex(/^[a-z0-9_-]{1,30}$/),
  name: text,
  durationDays: z.number().int().min(1).max(36500).nullable(),
  priceVnd: z.number().int().min(0).max(2000000000),
  listPriceVnd: z.number().int().min(0).max(2000000000).nullable().default(null),
  badge: z.string().max(100).nullable().default(null),
  note: z.string().max(2000).nullable().default(null),
  isActive: z.boolean(),
  sort: z.number().int().min(0).max(30000),
});
export const AdminGates = z.strictObject({
  note_max: z.number().int().min(1).max(10000),
  free_levels: z.number().int().min(0).max(5),
  p7_den: z.number().int().min(1).max(100),
  dictation_free_parts: z.array(z.number().int().min(1).max(7)).max(7),
});
export const AdminConfig = z.strictObject({ require_activation: z.boolean() });
